import React from "react";
import Footer from "./footer";
import NavBar from "./navbar";
import SEO from "./seo";

export default function Layout({ children, pageContext }) {
  const { uri = "", imageCarousel = [], seo = {} } = pageContext || {};
  return (
    <main>
      <SEO
        title={
          !seo?.title || seo?.title.includes("undefined")
            ? "Home | Air Mc Ltd"
            : seo?.title
        }
        calonical={seo?.calonical}
        meta={{ description: seo?.metaDesc, keywords: seo?.metaKeywords }}
        openGraph={{
          "og:title":
            !seo?.opengraphTitle || seo?.opengraphTitle.includes("undefined")
              ? "Home | Air Mc Ltd"
              : seo?.opengraphTitle,
          "og:description": seo?.opengraphDescription,
        }}
      />
      <NavBar />
      {children}
      <Footer uri={uri} imageCarousel={imageCarousel} />
    </main>
  );
}
